import Service from "../../../Services/index";
import moment from "moment";

const driver = {
    namespaced: true,
    state: {
        repair_list: [],
        form : {
            driver: null ,
            transport_type_id: "",
            list_name: "",
            license_plate: "",
            deposit_total: "",
            payer: "",
            amount: "",
            slip_file: "",
            date: "",
            deposit : ""
        },
        dataPaginate:{
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        }
    },
    mutations: {
        SET_REPAIR_COST: (state, res) => {
            state.repair_list = res.data;
            state.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            };
        },
        CLEAR_FORM_REPAIR : (state) => {
            state.form = {
                driver: null ,
                transport_type_id: "",
                list_name: "",
                license_plate: "",
                deposit_total: "",
                payer: "",
                amount: "",
                slip_file: "",
                date: "",
            }
        },
    },
    actions: {
        setRepair({ commit },page=1) {
            return Service.Repair.getRepair(page).then(data => {
                commit("SET_REPAIR_COST", data);
            });
        },
        show({ commit },id) {
            return Service.Repair.showRepair(id).then(data => {
                commit("CLEAR_FORM_REPAIR", data);
            });
        },
        save({ commit,state },{id,user,date}) {
            let data = {
                transport_type_id:state.form.transport_type_id,
                list_name :state.form.list_name,
                driver_id : state.form.driver.id,
                driver_name : state.form.driver.name,
                license_plate : state.form.license_plate,
                payer : user,
                amount:  parseFloat(state.form.amount),
                slip_file : state.form.slip_file,
                deposit_total : state.form.driver.deposit_total,
                date : date
            };
            if(!id){
                //create
                return Service.Repair.createRepair(data)
                    .then(()=>{
                    let account = {
                        driver_id : data.driver_id,
                        withdraw : data.amount,
                        date : data.date,
                        recipient : data.payer,
                        reason : data.list_name,
                    }
                    return Service.Deposit.createDeposit(account);
                });
            }else{
                //update
                return Service.Repair.updateRepair(id,data);
            }
        },
        delete({ commit },id) {
            return Service.Repair.deleteRepair(id);
        },
        searchRepair({commit},{page,search}){
            return Service.Repair.search(page,search)
                .then(data=>{
                    commit("SET_REPAIR_COST",data)
                })
        },
        clearform({commit}){
            commit("CLEAR_FORM_REPAIR");
        },
    }
};
export default driver;
